/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { PurchaseTemplateDetailResponseForTemplateTemplateOverviewApproversInner } from './purchase-template-detail-response-for-template-template-overview-approvers-inner';
// May contain unused imports in some cases
// @ts-ignore
import { PurchaseTemplateDetailResponseForTemplateTemplateOverviewCreatedBy } from './purchase-template-detail-response-for-template-template-overview-created-by';
// May contain unused imports in some cases
// @ts-ignore
import { PurchaseTemplateDetailResponseForTemplateTemplateOverviewSubmittedBy } from './purchase-template-detail-response-for-template-template-overview-submitted-by';
// May contain unused imports in some cases
// @ts-ignore
import { PurchaseTemplateDetailResponseForTemplateTemplateOverviewUserAccount } from './purchase-template-detail-response-for-template-template-overview-user-account';

/**
 * 
 * @export
 * @interface PurchaseTemplateDetailResponseForTemplateTemplateOverview
 */
export interface PurchaseTemplateDetailResponseForTemplateTemplateOverview {
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverview
     */
    'purchaseTemplateNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverview
     */
    'templateId': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverview
     */
    'templateName': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverview
     */
    'scopeDisclosure': PurchaseTemplateDetailResponseForTemplateTemplateOverviewScopeDisclosureEnum;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverview
     */
    'templateCategory': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverview
     */
    'templateDetail': string;
    /**
     * 
     * @type {PurchaseTemplateDetailResponseForTemplateTemplateOverviewSubmittedBy}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverview
     */
    'submittedBy': PurchaseTemplateDetailResponseForTemplateTemplateOverviewSubmittedBy;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverview
     */
    'submittedAt': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverview
     */
    'department': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverview
     */
    'purchaseReason': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverview
     */
    'purchaseDetails': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverview
     */
    'placeOfUse': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverview
     */
    'purposeOfUse': PurchaseTemplateDetailResponseForTemplateTemplateOverviewPurposeOfUseEnum;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverview
     */
    'url': string;
    /**
     * 
     * @type {number}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverview
     */
    'amount': number | null;
    /**
     * 
     * @type {PurchaseTemplateDetailResponseForTemplateTemplateOverviewUserAccount}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverview
     */
    'userAccount': PurchaseTemplateDetailResponseForTemplateTemplateOverviewUserAccount | null;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverview
     */
    'isOnDemandCard': boolean;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverview
     */
    'remarks': string;
    /**
     * 
     * @type {PurchaseTemplateDetailResponseForTemplateTemplateOverviewCreatedBy}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverview
     */
    'createdBy': PurchaseTemplateDetailResponseForTemplateTemplateOverviewCreatedBy;
    /**
     * 
     * @type {Array<PurchaseTemplateDetailResponseForTemplateTemplateOverviewApproversInner>}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverview
     */
    'approvers': Array<PurchaseTemplateDetailResponseForTemplateTemplateOverviewApproversInner>;
}

export const PurchaseTemplateDetailResponseForTemplateTemplateOverviewScopeDisclosureEnum = {
    public: 'PUBLIC',
    individual: 'INDIVIDUAL'
} as const;

export type PurchaseTemplateDetailResponseForTemplateTemplateOverviewScopeDisclosureEnum = typeof PurchaseTemplateDetailResponseForTemplateTemplateOverviewScopeDisclosureEnum[keyof typeof PurchaseTemplateDetailResponseForTemplateTemplateOverviewScopeDisclosureEnum];
export const PurchaseTemplateDetailResponseForTemplateTemplateOverviewPurposeOfUseEnum = {
    software: 'SOFTWARE',
    fixtures: 'FIXTURES',
    conference: 'CONFERENCE',
    entertainment: 'ENTERTAINMENT',
    travel: 'TRAVEL',
    other: 'OTHER',
    initialValue: 'INITIAL_VALUE'
} as const;

export type PurchaseTemplateDetailResponseForTemplateTemplateOverviewPurposeOfUseEnum = typeof PurchaseTemplateDetailResponseForTemplateTemplateOverviewPurposeOfUseEnum[keyof typeof PurchaseTemplateDetailResponseForTemplateTemplateOverviewPurposeOfUseEnum];


